/**
 * Metrics
 * Reducer to catch rents and suscriptions to send metrics
 * All through payload state, initialized on Manage payment to set parameters
 * The final event is into request success
 * Payload is avaliable to use with the last transaction by an executor
 */
import _ from 'underscore';
import Metrics from 'services/metrics';
import * as ACTIONS from '../actions/metrics';

const initialState = {
  payload: {},
};
// Set metrics
const setTagManager = (dataLayer) => {
  Metrics.newEvent(dataLayer);
};
/**
 *
 * Evaluate errors and where set metrics
 *
 */
const setMetricsError = (executor, payload) => {
  if(payload.tagManager) {
    const tagManagerEdited = {
      event:'Error',
      eventCategory : 'Errores',
      eventLabel : executor.error,
      eventAction : executor.error,
    }

    return setTagManager(tagManagerEdited);
  }
};

const setMetrics = (executor, payload) => {
  if(payload.tagManager) {
    return setTagManager(payload.tagManager);
  }
};

export default function metrics (state = initialState, action) {
  switch (action.type) {
    case ACTIONS.METRICS:
      const payload = action.payload;
      return Object.assign({}, state, {
        payload,
      });
      break;

    case ACTIONS.SEND_METRICS:
      const result = action.result;
      let currentPayload = _.clone(result.payload);

      if(result.executor.error) {
        setMetricsError(result.executor, result.payload);
      } else if(result.executor.success) {
        setMetrics(result.executor, result.payload);
        currentPayload = {};
      }

      /* Socializacion */
      if(result.success) {
          setMetrics(result.executor, result.payload);
          currentPayload = {};
      }

      return Object.assign({},
        state,
      {
        payload: currentPayload,
      });
      break;
    default:
      return state;
  }
}
